import React from 'react';
import { ButtonBase, IconButton, Skeleton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Cart } from './styles';

type Props = {
  title: string;
  value: any;
  selected: boolean;
  onSelect: () => void;
  onCancelClick?: () => void;
  icon?: React.ReactNode;
};

function CartFastFilter({ title, value, selected, onSelect, onCancelClick, icon }: Props) {
  return (
    <Cart>
      <ButtonBase className={`cart ${selected ? 'selected' : ''}`} onClick={onSelect}>
        {icon && <span className='card-icon'>{icon}</span>}
        <div className='card-content'>
          <div className='label'>
            <p>{title}</p>
          </div>
          {value >= 0 ? (
            <div className='value'>
              <p>{value}</p>
            </div>
          ) : (
            <Skeleton className='value-loading' variant='rounded' width={104} height={32} />
          )}
        </div>
      </ButtonBase>
      {selected && (
        <IconButton
          className='cancel-btn'
          size='medium'
          onClick={e => {
            e.stopPropagation();
            onCancelClick?.();
          }}
        >
          <CloseIcon fontSize='medium' />
        </IconButton>
      )}
    </Cart>
  );
}

export default CartFastFilter;
